/**
 * paymentMode.ts
 *
 * Single source of truth for the payment mode flag.
 * Read VITE_PAYMENT_MODE once and expose a typed helper.
 *
 * Supported values:
 *   'mock' → simulate payment locally (no Wompi call)
 *   'real' → use Wompi checkout (production / staging)
 */

type PaymentMode = 'mock' | 'real';

const RAW = (import.meta.env.VITE_PAYMENT_MODE as string | undefined) ?? 'real';

export const PAYMENT_MODE: PaymentMode = RAW === 'mock' ? 'mock' : 'real';

/**
 * Returns true when the app is running in mock payment mode.
 * Use this everywhere you need to branch between real and simulated payment.
 */
export function isMockMode(): boolean {
  return PAYMENT_MODE === 'mock';
}
